import { ScoreType } from '../../store/admin/eventFormats/store';
import { IAdminTeamResult } from '../../store/admin/teamResults/store';

import { TTeamFormatPrefix } from '../../scenes/admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { capitalizeFirstLetter } from '../utils';
import { TIFormatPrefix } from '../../store/admin/roundFormats/store';

export const displayPosition = (
  playerResult: IAdminTeamResult,
  selectedTeamFormat?: TTeamFormatPrefix | TIFormatPrefix,
  selectedScoreType?: ScoreType
) => {
  if (selectedScoreType) {
    const scoreType = capitalizeFirstLetter(ScoreType[selectedScoreType].toLowerCase());

    const teamFormatScoreType = `${selectedTeamFormat}${scoreType}`;

    const positionField = `${teamFormatScoreType}Position`;
    const tiedField = `${teamFormatScoreType}Tied`;

    const positionValue = playerResult[positionField as keyof IAdminTeamResult];

    const tiedValue = playerResult[tiedField as keyof IAdminTeamResult];

    return `${tiedValue ? 'T' : ''}${positionValue}`;
  }

  return '';
};
